import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MeetingDetailsService } from 'src/app/services/meeting-details.service';

@Component({
  selector: 'app-lab-test-form',
  templateUrl: './lab-test-form.component.html'
})
export class LabTestFormComponent implements OnInit {

  clinicalTypes!: any;
  clinicTypeLoading = false;
  // enum clinic, lab and surgery

  @Output() cancelPop: EventEmitter<any> = new EventEmitter();
  @Output() closePopAndSave: EventEmitter<any> = new EventEmitter();
  @Input() item: any;
  @Input() meetingAgendaItemId: any;
  @Input() meetingId: any;
  @Input() labTestResultId: any;
  loading = false;
  formGroup: UntypedFormGroup;
  files = [];
  deletedFiles = [];

  genders = [
    { name: 'agendaCase.male', id: 'male' },
    { name: 'agendaCase.female', id: 'female' },
  ];

  isCase;
  minDate = new Date();
  maxDate: Date;
  isValidDate = true;
  language = localStorage.getItem('language') || 'en';

  constructor(
    private detailsService: MeetingDetailsService,
    private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.clinicTypeLookupList();
    this.formGroup = this.formBuilder.group({
      lNumber: ['', [Validators.required]],
      doctorName: ['', [Validators.required]],
      ldate: ['', [Validators.required]],
      clinicTypeLookupId: ['', [Validators.required]]
    });
    if (this.item) {
      this.formGroup.controls.lNumber.setValue(this.item.lNumber);
      this.formGroup.controls.doctorName.setValue(this.item.doctorName);
      this.formGroup.controls.ldate.setValue(this.item.ldate);
      this.formGroup.controls.clinicTypeLookupId.setValue(this.item.clinicTypeLookupId);
      this.files = JSON.parse(JSON.stringify(this.item.attachments));
      this.files = this.files.filter(item => !item.isDeleted);
    }
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  clinicTypeLookupList() {
    this.clinicTypeLoading = true;
    this.detailsService.clinicTypeLookupList('lab').subscribe((data) => {
      this.clinicalTypes = data;
      this.clinicTypeLoading = false;
    })
  }

  saveItem() {
    if (this.formGroup.valid) {
      this.loading = true;
      let labTestResult;
      labTestResult = {
        lNumber: this.formGroup.controls.lNumber.value,
        doctorName: this.formGroup.controls.doctorName.value,
        ldate: this.formGroup.controls.ldate.value,
        clinicTypeLookupId: this.formGroup.controls.clinicTypeLookupId.value,
        meetingAgendaItemId: this.meetingAgendaItemId
      };

      if (this.item) {
        labTestResult.deletedAttachments = this.deletedFiles;
        labTestResult.id = this.labTestResultId;
      }

      this.detailsService.saveLabTest(labTestResult, this.files).subscribe(
        data => {
          this.loading = false;
          this.closePopAndSave.emit();
          if (this.item && this.item.pathologySlides) {
            this.detailsService.refreshSlides.next(true);
          }
        }, err => {
          console.error(err);
        });
    }
  }
  closePop() {
    this.cancelPop.emit();
  }
  counter(i: number) {
    return new Array(i);
  }

  clearDate(event) {
    event.stopPropagation();
    this.formGroup.controls.date.setValue('');
  }
  validateDates(value) {
    this.isValidDate = true;
    if (new Date(value) < new Date()) {
      this.isValidDate = false;
    }
  }

}
